import privacy1_0 from './1.0/privacyPolicy';
import tos1_0 from './1.0/termsOfService';
import privacy2_0 from './2.0/privacyPolicy';
import tos2_0 from './2.0/termsOfService';
import privacy3_0 from './3.0/privacyPolicy';
import tos3_0 from './3.0/termsOfService';
import privacy4_0 from './4.0/privacyPolicy';
import tos4_0 from './4.0/termsOfService';

import privacyRegional from './regional/privacyPolicy';

export interface IPolicy {
  version: string;
  content: Record<string, ({ appView }: { appView?: boolean }) => React.JSX.Element>;
}

export const DEFAULT_POLICY_LANGUAGE = 'en';

export const PRIVACY_POLICIES: IPolicy[] = [
  {
    version: '1.0',
    content: {
      en: privacy1_0,
    },
  },
  {
    version: '2.0',
    content: {
      en: privacy2_0,
    },
  },
  {
    version: '3.0',
    content: {
      en: privacy3_0,
    },
  },
  {
    version: '4.0',
    content: {
      en: privacy4_0,
    },
  },
  {
    version: 'regional',
    content: {
      en: privacyRegional,
    },
  },
];

export const TERMS_OF_SERVICE: IPolicy[] = [
  { version: '1.0', content: { en: tos1_0 } },
  { version: '2.0', content: { en: tos2_0 } },
  { version: '3.0', content: { en: tos3_0 } },
  { version: '4.0', content: { en: tos4_0 } },
];

export const LATEST_PRIVACY_POLICY = '4.0';
export const LATEST_TERMS_OF_SERVICE = '4.0';
